import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
} from "../../../../../AutoLayout/AutoLayoutEnums";
import { ThemeIconEnum } from "../../../../../../Themes/ThemeEnums";
import AutoLayout from "../../../../../AutoLayout/AutoLayout";
import { IconButton } from "../../../../../../Button";
import { useDispatch } from "react-redux";
import { appLeftNavToggleAction } from "../../../../../../../../Redux/AppCoreReducer";
import { useResource } from "../../../../../../../../Resources/useResource";
import { AppShellResources } from "../../../../../../../../Resources/AppShellResources";

const MenuButton: React.FC = () => {
  const dispatch = useDispatch();
  const t = useResource(AppShellResources);

  const menuClick = () => {
    dispatch(appLeftNavToggleAction());
  };

  return (
    <AutoLayout
      onClick={menuClick}
      $direction={AutoLayoutDirectionEnum.HORIZONTAL}
      $align={AutoLayoutAlignEnum.RIGHT}
    >
      <IconButton icon={ThemeIconEnum.MENU} ariaLabel={t.toggleNavigationAriaLabel} />
    </AutoLayout>
  );
};

export default MenuButton;
